<template>
	<div class="pages-works">
		<div class="bg-wrapper">
			<change-lang style="z-index: 99"></change-lang>
			<div class="small-logo" @click="toPage">
				<img src="../assets/comment/list-top-logo.png" alt="#" />
			</div>
			<div class="bg-music" @click="handelChange">
				<img v-if="canplay" src="../assets/comment/music-on.png" alt="#" />
				<img v-else src="../assets/comment/music-off.png" alt="#" />
			</div>
			<div class="works-header" :class="this.$i18n.locale">
				<div class="works-header-img">
					<div class="works-header-title-img" :class="this.$i18n.locale">
						<img v-if="!isMobile" class="title" :src="
								require(`../assets/pc-change-images/list-logo-${this.$i18n.locale}.png`)
							" alt="#" />
						<img v-if="isMobile" class="title" :src="
								require(`../assets/pc-change-images/m-list-logo-${this.$i18n.locale}.png`)
							" alt="#" />
					</div>
					<!-- <div class="works-header-btn-img" :class="this.$i18n.locale">
						<img class="btn" :src="
								require(`../assets/pc-change-images/list-uploadBtn-${this.$i18n.locale}.png`)
							" alt="#" @click="uploadWork" />
					</div> -->
				</div>
			</div>
			<div class="body-wrapper">
				<div class="works-body">
					<div class="text" :class="this.$i18n.locale">
						<img v-if="this.$i18n.locale === 'en' && isMobile" :src="require(`../assets/h5-list-text-${this.$i18n.locale}.png`)" alt="#" />
						<span v-else :class="{'isMobile': isMobile, 'zh': this.$i18n.locale === 'zh'}">{{ $t('works.text') }}</span>
					</div>
					<!-- <div class="search">
						<el-input v-model="searchVal" prefix-icon="el-icon-search" size="mini" @change="isMobile ? void 0 : search()"></el-input>

						<div v-if="isMobile" class="search-img-btn">
							<img :src="require(`../assets/list-search-${this.$i18n.locale}.png`)" alt="#" @click="search()" />
						</div>
					</div> -->
					<el-empty v-if="!loading && works.length === 0" description="暂时没有作品"></el-empty>
					<div v-else class="works-list">
						<div v-for="workObj in works" :key="workObj.page">
							<el-row :gutter="20">
								<el-col v-for="work in workObj.data" :key="work.project_key" :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
									<div class="work-card" @click="showWorkDetail(work)">
										<el-row>
											<el-col :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
												<div class="image-wrapper">
													<img :src="work.url" />
												</div>
											</el-col>
											<el-col :xs="12" :sm="12" :md="24" :lg="24" :xl="24">
												<div class="work-card-body">
													<span class="work-title" :title="work.title">{{ work.title }}</span>
													<span class="work-name" :title="work.creator_name">{{ work.creator_name }}</span>
													<span class="work-from" :title="work.creator_from">{{ work.creator_from }}</span>
												</div>
											</el-col>
										</el-row>
									</div>
								</el-col>
								<template>
									<div v-loading="loading"></div>
								</template>
							</el-row>
						</div>
						<div class="more-btn">
							<img
								v-if="hasNextPage"
								@click="loadMore()"
								:loading="loading"
								:src="
									require(`../assets/pc-change-images/list-moreBtn-${$i18n.locale}.png`)
								"
								alt="#"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="works-footer">
				<div class="works-footer-wrap">
					<img v-if="isMobile" src="../assets/m-list-logo.png" alt="#" />
					<img v-else src="../assets/logoFour.png" alt="#" />
				</div>

				<!-- <div class="top">
					<img src="../assets/comment/list-icon-top.png" alt="#" />
				</div>
				<div class="bottom">

					<img src="../assets/comment/icon-1.png" alt="#" @click="goOther(url.one)" />
					<img src="../assets/comment/icon-2.png" alt="#" @click="goOther(url.two)" />
					<img src="../assets/comment/icon-3.png" alt="#" @click="goOther(url.three)" />
					<img src="../assets/comment/icon-4.png" alt="#" @click="goOther(url.four)" />
					<el-popover placement="top" width="150" trigger="hover">
						<img style="width: 150px; height: 150px" src="https://uiru.cgtn.com/w/images/special/img-qrcode.png" alt="#" />
						<img slot="reference" src="../assets/comment/icon-5.png" alt="#" />
					</el-popover>
					<img src="../assets/comment/icon-6.png" alt="#" @click="goOther(url.six)" />
				</div>-->
			</div>
			<img class="imgGif1" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif2" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif3" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif4" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif5" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif6" src="../assets/xuehuadongtu.gif" />
			<img class="imgGif7" src="../assets/xuehuadongtu.gif" />
		</div>
	</div>
</template>

<script>
import ChangeLang from '../components/ChangeLang.vue'
export default {
	name: 'PagesWorks',
	components: { ChangeLang },
	data() {
		return {
			loading: false,
			response: null,
			works: [],
			page: 1,
			canplay: this.$root.play,
			searchVal: '',
			url: {
				one: 'https://www.facebook.com/cgtnrussian/',
				two: 'https://vk.com/cgtnrussian',
				three: 'https://twitter.com/cgtnrussian/',
				four: 'https://www.youtube.com/channel/UCA2WHG4EpVqul3TYjAF0k2A?view_as=subscriber',
				six: 'https://weibo.com/cgtnrussian'
			}
		}
	},
	computed: {
		hasNextPage() {
			if (!this.response) {
				return false
			}

			return this.response.current_page < this.response.last_page
		},
		isMobile() {
			if (
				navigator.userAgent.match(
					/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
				)
			) {
				return true
			} else {
				return false
			}
		}
	},

	methods: {
		handelChange() {
			let music = document.getElementById('audio')
			this.canplay = !this.canplay
			this.$root.play = this.canplay
			if (!this.canplay) {
				music.pause()
			} else {
				music.play()
			}
		},
		toPage() {
			window.open('https://russian.cgtn.com', '_blank')
		},
		search() {
			this.page = 1
			this.works = []
			this.load(this.page)
		},
		showWorkDetail(work) {
			this.$router.push(`work/${work.project_key}`)
		},
		uploadWork() {
			this.$router.push('/upload')
		},
		loadMore() {
			this.page++
			this.load(this.page)
		},
		isChinese(work) {
      if (!work) {
        return false
      }
      if (work.creator_from && work.creator_from === '中国') {
        return true
      }
      return false
		},
		load(page) {
			this.loading = true
			this.$axios
				.get('/works_'+this.page+'.json', {
					params: {
						page: page,
						search: this.searchVal || ''
					}
				})
				.then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '加载失败，请刷新重试')
					}
					this.response = res.data.data
					this.page = this.response.current_page
					const ws = res.data.data.data
					let results = []
					ws.forEach((w) => {
						w.title = this.isChinese(w) ? `《${w.title}》` : `“${w.title}”`
						results.push(w)
					})
					this.works.push({
						page: page,
						data: results
					})
				})
				.catch(() => {
					this.$message.error('加载失败，请刷新重试')
				})
				.finally(() => {
					this.loading = false
				})
		},
		goOther(url) {
			window.open(url)
		}
	},
	mounted() {
		this.load(this.page)
		if (localStorage.getItem('lang')) {
			this.$i18n.locale = localStorage.getItem('lang')
		}
	}
}
</script>

<style lang="stylus">
.pages-works {
  height: 100vh;
  overflow-y: scroll;

  .imgGif1 {
    width: 200px;
    height: 200px;
    position: absolute;
    left: -80px;
    top: 300px;
  }

  .imgGif2 {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 200px;
    top: 150px;
  }

  .imgGif3 {
    width: 80px;
    height: 80px;
    position: absolute;
    right: 200px;
    top: 80px;
  }

  .imgGif4 {
    width: 80px;
    height: 80px;
    position: absolute;
    right: 70px;
    top: 300px;
  }

  .imgGif5 {
    width: 60px;
    height: 60px;
    position: absolute;
    right: 70px;
    top: 700px;
  }

  .imgGif6 {
    width: 300px;
    height: 300px;
    position: absolute;
    left: -130px;
    bottom: 300px;
  }

  .imgGif7 {
    width: 200px;
    height: 200px;
    position: absolute;
    right: -70px;
    bottom: 80px;
  }

  .bg-wrapper {
    position: relative;
    width: 100vw;
    background: url('../assets/comment/list-bg.png') no-repeat;
    background-size: 100% auto;
    background-color: #09e2f6;
    overflow: hidden;
    --webkit-overflow-scrolling: touch;
  }

  .small-logo {
    cursor: pointer;
    z-index: 99;
    position: absolute;
    top: 16px;
    left: 56px;
    width: 100px;
    height: 100px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .bg-music {
    position: absolute;
    top: 120px;
    left: 90px;
    z-index: 99;
    width: 35px;
    height: 35px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .works-header {
    height: 460px;
    padding-top: 200px;
    margin-bottom: 80px;

    .works-header-img {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .works-header-title-img {
        width: 500px;

        &.en {
          width: 50%;
        }

        .title {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .works-header-btn-img {
        width: 160px;
        margin-top: 16px;
        cursor: pointer;

        &.en {
          width: 220px;
          margin-top: 80px;
        }

        .btn {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }

  .body-wrapper {
  }

  .works-body {
    width: 60%;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: rgba(171, 173, 226, 0.6);
    min-height: 500px;
    border-radius: 20px;

    .works-list {
      // padding: 0 30px;
      .work-card {
        margin-top: 20px;
        border-radius: 5px;
        box-shadow: 1px 1px 10px 4px rgba(0, 0, 0, 0.07);
        cursor: pointer;
        color: #409eff;

        .image-wrapper {
          height: 100px;
          border-radius: 5px 5px 0 0;
          background-color: grey;

          img {
            border-radius: 5px 5px 0 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .work-card-body {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100px;
          background-image: url('../assets/comment/work-bg.png');
          background-repeat: no-repeat;
          background-color: #fff;
          border-radius: 0 0 5px 5px;
          color: rgb(119, 137, 200);
          padding: 8px;
        }

        .work-title {
          margin-bottom: 5px;
          font-size: 14px;
          // font-weight: 500;
          // 两行溢出
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .work-name {
          margin-bottom: 5px;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .work-from {
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .text {
      font-size: 16px;
      color: #fff;
      text-indent: 28px;
    }

    .text.en {
      width: 100%;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .search {
      width: 100%;
      text-align: center;
      margin: 20px 0;

      .el-input__icon {
        font-size: 16px;
        color: #fff;
      }

      .el-input {
        width: 200px;
      }

      .el-input__inner {
        background-color: transparent;
        border: 2px solid #fff;
      }
    }

    .more-btn {
      text-align: center;
      margin-top: 40px;
      margin-bottom: 12px;
      cursor: pointer;

      img {
        width: 156px;
        height: 60px;
      }
    }
  }

  .works-footer {
    text-align: center;
    padding: 30px;
    width: 60%;
    margin: 30px auto 0;
    text-align: center;

    img {
      width: 100%;
    }
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .pages-works {
    .search-img-btn {
      text-align: center;
      width: 40%;
      margin: 0 auto;
      margin-top: 30px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .imgGif1 {
      width: 100px;
      height: 100px;
      position: absolute;
      left: -40px;
      top: 280px;
    }

    .imgGif2 {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 4px;
      top: 150px;
    }

    .imgGif3 {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 0px;
      top: 60px;
    }

    .imgGif4 {
      width: 70px;
      height: 70px;
      position: absolute;
      right: 0;
      top: 100px;
    }

    .imgGif5 {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 35px;
      top: 350px;
    }

    .imgGif6 {
      // width: 150px;
      // height: 150px;
      // position: absolute;
      // left: -40px;
      // bottom: 150px;
      display: none;
    }

    .imgGif7 {
      // width: 100px;
      // height: 100px;
      // position: absolute;
      // right: -30px;
      // bottom: -30px;
      display: none;
    }

    .small-logo {
      top: 16px;
      left: 16px !important;
      width: 60px !important;
      height: 60px !important;
    }

    .bg-music {
      width: 26px;
      height: 26px;
      top: 50px !important;
      left: 280px !important;
    }

    .change-lang {
      right: 30px !important;
      width: 100px !important;
    }

    .works-header {
      padding-top: 60px;
      height: 500px;
    }

    .bg-wrapper {
      background: url('../assets/mobileImagesBg/m-bg-list.png') no-repeat !important;
      background-color: #25daf6 !important;
      background-size: 100% auto !important;
    }

    .body-wrapper {
      margin-top: 170px !important;
    }

    .works-body {
      box-sizing: border-box;
      width: 90% !important;
      padding 20px 0 !important
      .text {
        padding 0 20px !important
        .isMobile {
          &.zh {
            font-size: 17px !important;
            line-height 35px
          }
        }
      }
      .search {
        box-sizing: border-box
        padding 0 30px !important
      }

      .text.en {
        box-sizing: border-box
        width: 100% !important;
        margin: 0 auto;
        text-indent: 0px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .image-wrapper {
        border-radius: 0 !important;
        height: 110px !important;

        img {
          border-radius: 0 !important;
        }
      }

      .work-card-body {
        border-radius: 0 !important;
        height: 110px !important;
        box-sizing: border-box;
        padding: 8px !important;
        background-image: url('../assets/works/work-card-body-bg.png') !important;
        background-position: right bottom;

        .work-title {
          font-size: 14px !important;
        }

        .work-name {
          font-size: 14px !important;
        }

        .work-from: {
          font-size: 12px !important;
        }
      }
    }

    .more-btn {
      img {
        width: 120px !important;
        height: 50px !important;
      }
    }

    .works-footer {
      width: 85% !important;
    }

    .works-header-title-img {
      width: 60% !important;
      margin-bottom: 70px;

      &.zh {
        width: 70% !important;
        padding-top: 150px !important;
      }

      &.en {
        padding-top: 50px !important;
        width: 100% !important;
        margin-bottom: 0px;
      }
    }

    .works-header-btn-img {
      width: 50%;

      &.zh {
        margin-top: 32px !important;
      }

      &.en {
        margin-top: 0px !important;
      }
    }
  }
}

/* 平板 */
@media screen and (min-width: 600px) and (max-width: 960px) {
  .works-body {
    padding: 0 16px;
  }
}
</style>
